import { yupResolver } from "@hookform/resolvers/yup"
import { useState } from "react"
import * as yup from "yup"

import DialogProvider from "@components/dialog_provider"
import TextInput from "@components/text_input"
import { UsersData, useCustomerPageContext } from "@contexts/customer"
import useControlledForm from "@hooks/use_controlled_form"
import { Stack } from "@mui/material"

export type PaymentFormData = {
  paymentMethod: string
  amount: number
}

export default function MarkPyementAsPaidDialog({
  isOpen,
  setClose,
  selectedRow
}: {
  isOpen: boolean
  selectedRow?: UsersData
  setClose: () => void
}) {
  const { translate } = useCustomerPageContext()

  const schema = yup
    .object({
      paymentMethod: yup
        .string()
        .required(translate("payment_method_field_is_required")),
      amount: yup.number().required(translate("amount_field_is_required"))
    })
    .required()

  const {
    control,
    handleSubmit,
    reset,
    formState: { isValid }
  } = useControlledForm<PaymentFormData>({
    resolver: yupResolver(schema),
    mode: "all"
  })

  // useEffect(() => {
  //   if (selectedRow) {
  //     reset({
  //       paymentMethod: selectedRow.paymentMethod as string,
  //       amount: selectedRow.amount as string
  //     })
  //   }
  // }, [selectedRow])

  const [loading, setLoading] = useState(false)

  function handleClose() {
    if (loading) {
      return
    }
    setClose()
    reset()
  }

  function onSubmit() {
    if (!selectedRow?.id) {
      return
    }

    setLoading(true)
    setLoading(false)
    handleClose()
  }

  return (
    <DialogProvider
      title={translate("mark_payement_as_paid")}
      leftButton={{
        text: translate("cancel"),
        color: "secondary",
        onClick: setClose,
        disabled: loading
      }}
      rightButton={{
        text: translate("save"),
        color: "primary",
        onClick: handleSubmit(onSubmit),
        loading: loading,
        disabled: !isValid
      }}
      isOpen={isOpen}
      setClose={handleClose}
      size="small"
    >
      <Stack gap={1}>
        <TextInput<PaymentFormData>
          type="select"
          label={translate("payment_method")}
          disabled={loading}
          name="paymentMethod"
          placeholder={translate("select")}
          control={control}
          selectOptions={[
            { label: "Bank Transfer", value: "BANK" },
            { label: "Cash", value: "CASH" }
          ]}
        />

        <TextInput<PaymentFormData>
          type="number"
          label={translate("amount")}
          disabled={loading}
          name="amount"
          placeholder="0"
          control={control}
        />
      </Stack>
    </DialogProvider>
  )
}
